import React from "react";
import { MathUtils } from "three";
import Sound from "../Viewer/Sound";

const ModelInstance = ({ model, instance }) => {
  if (!model || !instance) {
    return null;
  }

  const clone = model.scene.clone();

  return (
    <primitive
      name={instance.name}
      object={clone}
      position={instance.position}
      rotation={[
        MathUtils.degToRad(instance.rotation[0]),
        MathUtils.degToRad(instance.rotation[1]),
        MathUtils.degToRad(instance.rotation[2]),
      ]}
      scale={instance.scale}
    >
    </primitive>
  );
};

export default ModelInstance;
